///////////////////////////
// TRAVELERS PREFERENCES
// TODO: get fields
export interface TravelersPreferences {
  someValue: string;
}

export const travelersPreferences = {
  someValue: '',
};

///////////////////////////
// PLACES PREFERENCES
export interface PlacesPreferences {
  num_of_reviews: number[]; // WHAT IS RANGE?
  star_rating_stays: number[]; // 0..5
  star_rating_dining: number[]; // 0..5
  star_rating_places: number[]; // 0..5
  included_collections: string[]; // Use same as in UX
}

export const placesPreferences = {
  num_of_reviews: [1000, 1000],
  star_rating_stays: [2, 5],
  star_rating_dining: [2, 5],
  star_rating_places: [2, 5],
  included_collections: ['My Saved Places', 'Matches to Preferences', 'Special Places at Destination'],
};

///////////////////////////
// MEALS PREFERENCES
export interface MealsPreferences {
  include_breakfast: boolean;
  include_lunch: boolean;
  include_dinner: boolean;
  breakfast_time_window: number[]; // 0 - 3600 * 24
  lunch_time_window: number[]; // 0 - 3600 * 24
  dinner_time_window: number[]; // 0 - 3600 * 24
  eatin_dineout_mixture: number; // 0..1
  // grocery_per_day: number,         // NOT PRESENT IN API
  // include_tea_coffe: boolean,      // NOT PRESENT IN API
  // include_snacks: boolean,         // NOT PRESENT IN API
  // happy_hours_per_day: boolean,    // NOT PRESENT IN API
}

export const mealsPreferences = {
  include_breakfast: false,
  include_lunch: false,
  include_dinner: false,
  breakfast_time_window: [9, 12],
  lunch_time_window: [13, 15],
  dinner_time_window: [16, 20],
  eatin_dineout_mixture: 0.5,
  grocery_per_day: 1,
  include_tea_coffe: false,
  include_snacks: false,
  happy_hours_per_day: 1,
};

///////////////////////////
// TIMING PREFERENCES
export interface TimingPreferences {
  // activity_duration_multiplier: number,      // NO SUCH FIELD IN UX
  // maximum_activities_per_day: number,        // NO SUCH FIELD IN UX
  minimum_break_between_activities: number; // In sec. Time between activities.
  activity_time_window: number[]; //
  activity_time_total: number[]; // Activities.
  activity_buffer_time: number[]; // TODO: NO SUCH FIELD IN UX
  breakfast_time_window: number[]; // Breakfast Window.
  lunch_time_window: number[]; // Lunch Window.
  dinner_time_window: number[]; // Dinner Window.
  idle_time: number[]; // Sitting.
  light_activity_time: number[]; // Walking / Activities.
  intensive_activity_time: number[]; // Exercise & Sports
}

export const timingPreferences: TimingPreferences = {
  // activity_duration_multiplier: 1,
  // maximum_activities_per_day: 3,
  minimum_break_between_activities: 3600,
  activity_time_window: [0, 3600 * 24],
  activity_time_total: [0, 3600 * 24],
  activity_buffer_time: [0, 3600 * 24],
  breakfast_time_window: [3600 * 8, 3600 * 12],
  lunch_time_window: [3600 * 12, 3600 * 16],
  dinner_time_window: [3600 * 16, 3600 * 24],
  idle_time: [],
  light_activity_time: [],
  intensive_activity_time: [],
};

///////////////////////////
// TRANSIT PREFERENCES
export enum TransitModes {
  WALK = 'WALK',
  DRIVE = 'DRIVE',
  BIKE = 'BIKE',
  TRANSIT = 'TRANSIT',
  TAXI = 'TAXI',
}
export interface TransitPreferences {
  allow_walking: boolean;
  allow_transit: boolean;
  allow_driving: boolean;
  max_walking_time_per_day: number; // in seconds
  max_transit_time_per_day: number; // in seconds
  max_driving_time_per_day: number; // in seconds
  max_mobility_time_per_day: number; // in seconds
  allowed_modes: TransitModes[]; //
}

export const transitPreferences: TransitPreferences = {
  allow_walking: true,
  allow_transit: true,
  allow_driving: true,
  max_walking_time_per_day: 3600, // in seconds
  max_transit_time_per_day: 3600, // in seconds
  max_driving_time_per_day: 3600, // in seconds
  max_mobility_time_per_day: 3600, // in seconds
  allowed_modes: [TransitModes.WALK], // WALK, DRIVE, BIKE, TRANSIT, TAXI
};

///////////////////////////
// DAY PLANS PREFERENCES
export interface DayPlan {
  date: string; // YYYY-MM-DD
  theme: string; // Same as in UX
}

export type DayPlansPreferences = DayPlan[];

export const dayPlansPreferences = [
  {date: '2023/08/01', theme: 'Explore'},
  {date: '2023/08/02', theme: 'Explore'},
  {date: '2023/08/03', theme: 'Explore'},
  {date: '2023/08/04', theme: 'Explore'},
  {date: '2023/08/05', theme: 'Explore'},
  {date: '2023/08/06', theme: 'Explore'},
  {date: '2023/08/07', theme: 'Explore'},
];

///////////////////////////
// BUDGETE PREFERENCES
export interface BudgetPreferences {
  price_tolerance: number;
  stay_budget_per_day: number[];
  experience_budget_per_day: number[];
  dining_budget_per_day: number[];
}

export const budgetPreferences = {
  price_tolerance: 0.5,
  stay_budget_per_day: [0, 1],
  experience_budget_per_day: [0, 1],
  dining_budget_per_day: [0, 1],
};

///////////////////////////
export interface ItineraryPreferencesState {
  travelersPreferences: TravelersPreferences;
  placesPreferences: PlacesPreferences;
  mealsPreferences: MealsPreferences;
  timingPreferences: TimingPreferences;
  transitPreferences: TransitPreferences;
  dayPlansPreferences: DayPlansPreferences;
  budgetPreferences: BudgetPreferences;
}

export const itineraryPreferencesInitialState: ItineraryPreferencesState = {
  travelersPreferences,
  placesPreferences,
  mealsPreferences,
  timingPreferences,
  transitPreferences,
  dayPlansPreferences,
  budgetPreferences,
};
